(function(){
  function fix(){
    var sels = ['.dwx7-card__bg', '.dwx7-card__overlay', '.dwx7-card__theme'];
    sels.forEach(function(sel){
      var nodes = document.querySelectorAll(sel);
      for (var i = 0; i < nodes.length; i++) {
        nodes[i].style.setProperty('display','block','important');
      }
    });
  }
  if (document.readyState !== 'loading') fix();
  else document.addEventListener('DOMContentLoaded', fix);
  setTimeout(fix, 100);
  setTimeout(fix, 500);
  setTimeout(fix, 1500);
})();
